import { Input } from 'antd';
import React from 'react';
import { DebounceInput } from 'react-debounce-input';

import { DEBOUNCE_TIME } from 'constants/Global';

/** @type {React.FC<import("antd/es/input").TextAreaProps>} */
const DebounceTextArea = React.forwardRef(({ children, ...props }, ref) => (
  <DebounceInput
    debounceTimeout={DEBOUNCE_TIME}
    element={Input.TextArea}
    {...props}
    inputRef={ref}
  >
    {children}
  </DebounceInput>
));

export default DebounceTextArea;
